import { useVideoSources } from '@/hooks/useVideoSources';
import { cn } from '@/utils/cn';

const VIDEO_SOURCES = [
  { src: '/videos/daily-bonus/daily-bonus-beam-active.mov', type: 'video/quicktime' },
  { src: '/videos/daily-bonus/daily-bonus-beam-active.webm', type: 'video/webm' },
];

const VIDEO_POSTER = '/videos/daily-bonus/daily-bonus-beam-active-poster.webp';

interface DailyRewardBeamVideoProps {
  className?: string;
}

export function DailyRewardBeamVideo({ className }: DailyRewardBeamVideoProps) {
  const { videoProps, sources } = useVideoSources({
    sources: VIDEO_SOURCES,
  });

  return (
    <span
      aria-hidden
      className={cn('pointer-events-none absolute -inset-px overflow-hidden rounded-[inherit]', className)}
    >
      <video
        {...videoProps}
        muted
        poster={VIDEO_POSTER}
        className="absolute inset-0 size-full object-cover motion-reduce:hidden"
      >
        {sources.map(source => (
          <source key={source.src} src={source.src} type={source.type} />
        ))}
      </video>
      {/* Reduced motion: the static poster instead of the looping beam. */}
      <img src={VIDEO_POSTER} alt="" className="absolute inset-0 size-full object-cover hidden motion-reduce:block" />
    </span>
  );
}
